import Icons, { IconNames } from './icons';
import './icon.scss';
import React, { SVGProps } from 'react';
import classNames from 'classnames';

interface IconProperties {
  icon: IconNames;
  title?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
  dataCy?: string;
}

const Icon: React.FC<SVGProps<SVGSVGElement> & IconProperties> = ({ icon, size = 'medium', stroke, ...props }) => {
  return (
    <React.Fragment>
      {Icons[icon]({ className: classNames('icon', size), stroke: stroke || 'var(--grey-500)', ...props })}
    </React.Fragment>
  );
};

export default Icon;
